import React from 'react'
import { inject, observer } from 'mobx-react'
import Developer from './Developer'
import { Card } from 'antd'
import NullPol from './NullPol'

import * as styles from './style.scss'

@inject((store: any) => {
    const { authStore } = store
    return { authStore }
})
@observer
export default class extends React.Component {
    render() {
        return (
            <div className={styles.dashboard}>
                {this.props.authStore.roles.includes('developer') ? (
                    <Card headStyle={{ backgroundColor: '#dadce0' }} bodyStyle={{ padding: '0.7rem' }} title={'dev'}>
                        <Developer />
                    </Card>
                ) : (
                    ''
                )}
                <Card
                    headStyle={{ backgroundColor: '#dadce0' }}
                    bodyStyle={{ padding: '0.7rem' }}
                    title={'ביטוח ללא מזהה פוליסה'}
                >
                    <NullPol />
                </Card>
            </div>
        )
    }
}
